import { changeWithKey } from 'redux-form';
import { delay } from 'redux-saga';
import { fork, call, put, takeLatest } from 'redux-saga/effects';

import * as actions from './BusinessIntroductionDE.actions';
import {
    fetchCompaniesLookup,
    extractValuesFromGermanCompanySearchApiResponse,
    fetchLegalForm
} from '../../utils/Api';

function* companySearchSaga() {
    yield takeLatest(actions.COMPANIES_FETCH_REQUESTED_DE, function* (action) {
        yield call(delay, 250);
        const { companyName, postcode } = action.searchTerms;

        const companies = yield call(
            fetchCompaniesLookup,
            companyName,
            postcode,
            extractValuesFromGermanCompanySearchApiResponse
        );
        yield put({ type: 'COMPANIES_FETCH_SUCCEED', companies });
    });
}

function* legalFormSaga() {
    yield takeLatest(actions.LEGAL_FORM_FETCH_REQUESTED_DE, function* (action) {
        yield call(delay, 250);
        const legalForm = yield call(fetchLegalForm, action.crefoId);
        yield put(
            changeWithKey(
                'sign_up',
                'businessTypeFields',
                'company.type',
                legalForm
            )
        );
    });
}

export default [fork(companySearchSaga), fork(legalFormSaga)];
